import React from "react";
import classnames from 'classnames';

import {__, sprintf} from "@wordpress/i18n";
import {dispatch} from '@wordpress/data';

import {RemovableChip} from '@woocommerce/blocks-components';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {formatPrice} from '@woocommerce/price-format';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";
import './vouchers-list.scss';

const AppliedPromotionsList = () => {
    const {removeAllGiftCards, getAppliedPromotionsList, removeAllPromotions, isLoading} = useStoreCartVouchers();

    const formWrapperClass = 'wc-block-components-totals-coupon__content';

    const onPromotionRemove = (e, promotionCode) => {
        e.preventDefault();

        removeAllPromotions( promotionCode )
            .finally(() => dispatch( CART_STORE_KEY ).invalidateResolutionForStore());
    }

    return (
        <div className={ formWrapperClass }>
            <div className={classnames(
                "wc-block-components-totals-vouchers__content",
                "wc-block-components-totals-gift-cards__content"
            )}>
                <span className="wp-block-woocommerce-cart-order-summary-heading-block wc-block-cart__totals-title">{
                    __('Applied promotions', 'voucherify')
                }</span>
                <div className={classnames(
                    "wp-block-woocommerce-cart-order-summary-subtotal-block",
                    "wc-block-components-totals-wrapper"
                )}>
                    <div className="wc-block-components-totals-item">
                        <ul className="wc-block-components-totals-discount__coupon-list">
                            {getAppliedPromotionsList().map(([couponCode, couponParams], index) => (
                                <RemovableChip
                                    key={ 'coupon-' + couponCode }
                                    className="wc-block-components-totals-discount__coupon-list-item"
                                    text={ <>{typeof couponParams === 'object' ? couponParams.name : couponCode}:
                                        <span className={"amount-deducted"}>-{
                                            formatPrice((typeof couponParams === 'object' ?
                                                couponParams.amount : couponParams) * 100)
                                        }</span></> }
                                    screenReaderText={ sprintf(
                                        /* translators: %s Coupon code. */
                                        __( 'Promotion: %s', 'voucherify' ),
                                        typeof couponParams === 'object' ? couponParams.name : couponCode
                                    ) }
                                    disabled={ isLoading }
                                    onRemove={ (e) => onPromotionRemove(e, couponCode) }
                                    radius="large"
                                    ariaLabel={ sprintf(
                                        /* translators: %s is a coupon code. */
                                        __('Remove promotion "%s"', 'voucherify'),
                                        typeof couponParams === 'object' ? couponParams.name : couponCode
                                    ) }
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppliedPromotionsList;
